import styled from 'styled-components';

import SelectInput from '../../../components/SelectInput/SelectInput';

export const BreakSelection = styled.div<{ isSmallScreen: boolean }>`
	display: flex;
	flex-direction: row;
	width: 100%;
	height: 55px;
	color: ${({ theme }) => theme.colors.white};
	font-size: ${({ isSmallScreen }) => (isSmallScreen ? '14px' : '20px')};
`;

export const BreakSelectionButton = styled.button<{ selected: boolean }>`
	flex: 1;
	margin: 0;
	background-color: ${({ theme, selected }) => (selected ? theme.colors.darkGreyR : theme.colors.darkR)};
	cursor: pointer;
	border: none;

	&:focus {
		outline: none;
	}

	&:hover {
		opacity: 0.8;
	}
`;

export const HighlightedText = styled.p`
	margin-bottom: 5px;
	font-weight: 600;
`;

export const TermItemText = styled.p`
	padding-left: 10px;
	margin-bottom: 5px;
`;

export const StyledSelectInput = styled(SelectInput)<{ isSmallScreen: boolean }>`
	margin: ${({ isSmallScreen }) => (isSmallScreen ? '20px 0' : '50px 0')};
`;

export const BreakInfoSection = styled.section<{ isSmallScreen: boolean }>`
	background-color: ${({ theme }) => theme.colors.lightGreyR};
	margin: ${({ isSmallScreen }) => (isSmallScreen ? '8px 0' : '14px 0')};
	padding: ${({ isSmallScreen }) => (isSmallScreen ? '14px 20px' : '14px 28px')};
`;

export const ModalText = styled.p<{ isSmallScreen: boolean }>`
	text-align: center;
	margin-bottom: ${({ isSmallScreen }) => (isSmallScreen ? '20px' : '30px')};
	font-size: ${({ isSmallScreen }) => (isSmallScreen ? '14px' : '18px')};
`;